import React from "react";
import "./dashes.css";

export const Dashes = () => {
  return (
    <div className="dashes-line">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
